(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.cookie_compliance = {
    attach: function (context, settings) {
      if (typeof context['location'] !== 'undefined') {
      }
    }
  };

  $(document).ready(function(){
    $('.gdpr_popup__content__categories').css('display', 'none');

    $('.gdpr_popup__content__buttons .manage-cookies--link').click(function(e){
      e.preventDefault();
      $('.gdpr_popup__content__categories').slideDown();
      $(this).css('display', 'none');
      $('.gdpr_popup__content__buttons .save-preferences--link--container').show();
    });
  })

})(jQuery, Drupal);
